import React, {useContext, useState} from 'react';
import * as R from 'ramda';
import {ButtonGroup, TabContent, TabPane, Button} from 'reactstrap';
import classnames from 'classnames';
import {RevenueCtx} from '@/contexts';

import Detail from '@/internal/pages/Revenue/Payin/Detail';
import ItemList from '@/internal/pages/Revenue/Payin/ItemList';

const PayIn = () => {
  const [activeTab, setActiveTab] = useState(1);
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const data = useContext(RevenueCtx);
  const payin = R.pathOr({}, ['payin'], data);
  const payinItems = R.propOr([], 'items', payin);
  const {false: outstandingItems = [], true: settledItems = []} = R.groupBy(
    R.prop('fullySettled')
  )(payinItems);

  const tabData = [
    {
      id: 1,
      displayText: 'Outstanding',
      items: outstandingItems,
      installmentNoInitVal: settledItems.length,
    },
    {
      id: 2,
      displayText: 'Settled',
      items: settledItems,
      installmentNoInitVal: 0,
    },
    {id: 3, displayText: 'All', items: payinItems, installmentNoInitVal: 0},
  ];

  return (
    <>
      <Detail />
      <div className='pt-4'>
        <ButtonGroup className='pb-4'>
          {R.map(
            tab => (
              <Button
                key={tab.id}
                outline
                color='secondary'
                className={classnames({active: activeTab === tab.id})}
                onClick={() => {
                  toggle(tab.id);
                }}
              >
                {tab.displayText}{' '}
                <span className='badge badge-light'>{tab.items.length}</span>
              </Button>
            ),
            tabData
          )}
        </ButtonGroup>
        <TabContent activeTab={activeTab}>
          {R.map(
            tab => (
              <TabPane tabId={tab.id} key={tab.id}>
                <ItemList
                  items={tab.items}
                  installmentNoInitVal={tab.installmentNoInitVal}
                />
              </TabPane>
            ),
            tabData
          )}
        </TabContent>
      </div>
    </>
  );
};

export default PayIn;
